module.exports = __webpack_public_path__ + "img/123.5f4e82a0.png";